// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title--rIfRhQJn {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #6d6d6d;\n  text-align: center;\n  position: relative;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.eventCategory--2ouIajLI {\n  color: var(--antd-text-color-secondary);\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.title--rIfRhQJn.upstreamSource--2x9U2ngA {\n  color: var(--antd-link-color);\n  font-weight: 400;\n}\n\n.title--rIfRhQJn.upstreamSource--2x9U2ngA:hover {\n  color: var(--antd-link-hover-color);\n}\n\n.clickable--1NTjlvDW:hover {\n  color: var(--antd-link-color);\n  cursor: pointer;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "title--rIfRhQJn",
	"eventCategory": "eventCategory--2ouIajLI",
	"upstreamSource": "upstreamSource--2x9U2ngA",
	"clickable": "clickable--1NTjlvDW"
};
export default ___CSS_LOADER_EXPORT___;
